import { Tooltip } from '../common'
import { ROLES } from '../../constants/roles'
import { formatRegulationName, searchRegulationName } from '../../utils/regulationLabels'

// A search can span several destination regulations. Keep one note beside the
// results and describe only the sources whose prices were re-checked.
export default function BorrowedSearchNote({ sources = [], role, mappings = [] }) {
  const borrowed = sources.filter((source) => source?.borrowed)
  if (!borrowed.length) return null

  const names = [...new Set(borrowed.map((source) => formatRegulationName(source.regulation_name) || searchRegulationName(source.regulation, mappings)).filter(Boolean))]
  const donors = [...new Set(borrowed.map((source) => formatRegulationName(source.search_regulation)).filter(Boolean))]
  const internal = [ROLES.SUPER_ADMIN, ROLES.INTERNAL_ORG_ADMIN].includes(role)
  const text = `Checked on your ${names.join(', ') || 'local'} prices`

  return (
    <p className="text-xs text-[var(--wf-color-text-muted)]">
      {internal && donors.length ? (
        <Tooltip content={`Search source: ${donors.join(', ')}`}>
          <span tabIndex={0}>{text}</span>
        </Tooltip>
      ) : text}
    </p>
  )
}
